//Contains custom code that extends/wraps/uses the angular ui-router module.

(function (angular) {
  "use strict";

  angular
    .module("alk.uirouter")
    .service("stateService", ["$rootScope", "$state", "$timeout", function ($rootScope, $state, $timeout) {

      //Wrapper for ui-router's $state.go that will fire an event that lets controllers abort the $state.go call by calling event.preventDefault()
      //If using this module for checking unsaved changes before state change, then all $state.go calls should be replaced with this except for cases
      //where you want to go without the check, in which cases you should just use goWithoutChecks (or $state.go, if this service hasn't been loaded yet, as in app.js)
      function go(to, toParams, options) {
        var e = $rootScope.$broadcast("attemptStateChange", to, toParams, options);
        if (e.defaultPrevented) {
          return null;
        }
        return $state.go(to, toParams, options);
      }

      //Same as above, but sometimes you want to run code BEFORE the state change, but AFTER the handler responds, i.e. as cleanup before the state transitions
      //If so, put the function as the first variable to this call. The function won't be run if the handler prevents the event
      function goWithCallback(funcToRunBeforeStateChange, to, toParams, options) {
        var e = $rootScope.$broadcast("attemptStateChange", to, toParams, options);
        if (e.defaultPrevented) {
          return null;
        }
        funcToRunBeforeStateChange();
        return $state.go(to, toParams, options);
      }

      //A simple wrapper to $state.go. This exists for purpose clarity and readability only. (May be updated in the future to contain more logic)
      function goWithoutChecks(to, toParams, options) {
        return $state.go(to, toParams, options);
      }

      //Panel transition slide code.
      function handleSlide(trans, slideSpeedInMs) {

        var fromState = trans.$from();
        var toState = trans.$to();
        var fromParams = trans.params("from");
        var toParams = trans.params("to");

        if (!fromState) {
          return true;
        }

        //Handle the panel slide animation when it's closed or changed
        //Remove persisting slide classes first by default from the previous transition
        if ($rootScope.leftPanelSlideClass) {
          angular.element(".left-panel-ui-view").removeClass("panelSlideLeft");
          angular.element(".left-panel-ui-view").removeClass("panelSlideRight");
          $rootScope.leftPanelSlideClass = "";
        }

        //Don't slide for panel in/out, since it slides already
        if(toState.name === "main" || fromState.name === "main") {
          return true;
        }

        var subpanel =
          (fromState.name.startsWith("main.") && toState.name.startsWith("main.")) ||
          (fromState.name.startsWith("reports.") && toState.name.startsWith("reports."));

        //These transitions only apply to subpanels, not whole pages, so "main." transitions
        if (subpanel && fromState.name !== toState.name) {
          //If transitioning from a parent state to a child state (i.e. main.places ==> main.places.set), slide left (forward)
          if (toState.name.startsWith(fromState.name)) {
            angular.element(".left-panel-ui-view").removeClass("panelSlideRight"); //Set the current panel's scroll direction
            angular.element(".left-panel-ui-view").addClass("panelSlideLeft");
            $rootScope.leftPanelSlideClass = "panelSlideLeft"; //The new panel doesn't exist yet for DOM manipulation, so need to set a prospective variable
          }
          //If transitioning from a child state to a parent state (i.e. main.places.set ==> main.places), slide right (backward)
          else if (fromState.name.startsWith(toState.name)) {
            angular.element(".left-panel-ui-view").removeClass("panelSlideLeft");
            angular.element(".left-panel-ui-view").addClass("panelSlideRight");
            $rootScope.leftPanelSlideClass = "panelSlideRight";
          }
          //If transitioning between siblings (i.e. main.places ==> main.search): close the current panel, then open new one
          else {
            $state.go("main").then(function () {
              $timeout(function () {
                $state.go(toState.name, toParams);
              }, slideSpeedInMs);
            });
            return false;
          }
        }
        return true;
      }

      return {
        go: go,
        goWithCallback: goWithCallback,
        goWithoutChecks: goWithoutChecks,
        handleSlide: handleSlide
      };

  }]);
})(window.angular);



// WEBPACK FOOTER //
// ./~/@trimblemaps/webtools-common/javascript/AngularJS/alk-uirouter/stateService.js